module.exports = __webpack_public_path__ + "static/media/brasil-flag.dade8d55.png";